/**
 * 区域管理路由配置
 */
const areaRoutes = {
  path: 'area',
  name: 'area',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'areaList',
      component: () => import(/* webpackChunkName: "areaList" */'@/features/gnmk/area/index.vue'),
      meta: {
        navtabTitle: '区域管理',
        isCache: true,
        ignoreDiff: [],
        isIframe: false
      }
    }
  ]
};

export default areaRoutes;
